module.exports = __webpack_public_path__ + "static/media/truck-moving.fc8a852f.svg";